const Content_tabs = (function () {

    const $ = require('jquery');
    const self = {};

    let $content_tabs = $('.ce-content-tabs');

    self.calculateHeight = function () {

        if (Foundation.MediaQuery.atLeast('large')) {

            let $activeTab = $content_tabs.find('.tabs-panel.is-active').parent();
            let activeTabHeight = $activeTab.outerHeight();
            let titleHeight = $('[data-title-height]').outerHeight(true);

            $content_tabs.find('.tabs').height(activeTabHeight - titleHeight);

        } else {

            $content_tabs.find('.accordion').height('auto');

        }

    };

    self.init = function () {

        if ($content_tabs.length > 0) {

            App.Globals.$document.on('change.zf.tabs', function () {
                self.calculateHeight();
            });

            App.Globals.$window.on('load resize', function () {
                self.calculateHeight();
            });

        }

    };

    return self;

}());

module.exports = Content_tabs;
